module.exports = __webpack_public_path__ + "static/media/maskModal.8fe671d5.svg";